import * as z from "zod";

export const SupportV2ReconcileResultSchema = z.object({
  candidates: z.number(),
  deleted: z.number(),
  orphansClosed: z.number(),
  v2OnlyClosed: z.number(),
  legacyChanged: z.number(),
  dedupeClosed: z.number(),
  total: z.number(),
  dryRun: z.boolean(),
});

export const getSupportV2ReconcileResult = {
  name: "getSupportV2ReconcileResult" as const,
  input: z.object({ workflowId: z.string() }).strict(),
  output: z.object({
    status: z.enum(["running", "completed", "failed", "cancelled", "unknown"]),
    result: SupportV2ReconcileResultSchema.nullable(),
    error: z.string().nullable(),
  }),
};
